// Client for Marketing's "Ready for you" (apps/api/src/moves.ts).
import { request } from "../api";

export type MoveKind = "reply" | "follow_up" | "event_follow_up" | "event_push" | "win_back" | "reuse";
export type Draft = { channel: "email" | "linkedin" | "tasks"; subject?: string; body: string; date?: string | null };
export type Move = {
  key: string; kind: MoveKind; title: string; why: string; quote?: string | null;
  evidence: { label: string; number?: string }[]; at: string; when: string; value?: number | null;
  to?: { name: string; email: string | null; company?: string | null; title?: string | null } | null;
  reach?: string | null; owner?: { id: string | null; name: string | null } | null;
  draft: Draft; action: { label: string; does: string };
  assign?: { lead: string; name: string; company: string | null; title: string | null; rating: string | null; ownerId: string | null }[];
  people?: { id: string; name: string }[];
  written: { by: "courage" | "rules"; model?: string | null };
};
export type Done = { key: string; kind: MoveKind; at: string; title: string; summary: string; records: string[] };
export type Moves = { moves: Move[]; done: Done[]; skipped: number; ai: boolean; outlook: boolean };
export type Approved = { ok: true; title: string; summary: string; records: string[]; sent: boolean; mailto: string | null };

const B = "/api/marketing/moves";
const k = (key: string) => encodeURIComponent(key);
export const moves = {
  list: (mine = false) => request<Moves>("GET", mine ? `${B}?mine=1` : B),
  write: (key: string, b: { instruction?: string; draft?: Draft }) => request<{ draft: Draft; model: string }>("POST", `${B}/${k(key)}/write`, b),
  approve: (key: string, b: { draft: Draft; to?: string; assign?: { lead: string; ownerId: string }[] }) => request<Approved>("POST", `${B}/${k(key)}/approve`, b),
  skip: (key: string) => request<{ ok: true }>("POST", `${B}/${k(key)}/skip`, {}),
  restore: (key: string) => request<{ ok: true }>("POST", `${B}/${k(key)}/restore`, {}),
};

/** Where a record number opens. */
export const hrefOf = (n: string) => n.startsWith("LEAD-") ? `/marketing/leads/${n}` : n.startsWith("ACC-") ? `/accounts/${n}` : n.startsWith("CMP-") ? `/marketing/campaigns/${n}`
  : n.startsWith("EML-") ? `/marketing/emails/${n}` : n.startsWith("SEQ-") ? `/marketing/sequences/${n}` : n.startsWith("CNT-") ? `/marketing/calendar?view=list` : n.startsWith("OPP-") ? `/opportunities/${n}` : `/r/${n}`;
export const CHANNEL: Record<Draft["channel"], { label: string; cls: string }> = {
  email: { label: "Email", cls: "ch-email" }, linkedin: { label: "LinkedIn", cls: "ch-linkedin" }, tasks: { label: "Call tasks", cls: "ch-webinar" },
};
